function ProjectAchievements({ title = 'Achievements', achievements = [] }) {
  if (!achievements || achievements.length === 0) return null;

  return (
    <div id="achievements" className="mb-16 scroll-mt-32">
      <div className="prose prose-lg">
        {title && (
          <h2 className="text-lg font-medium text-[#0D0D0D] mb-6">
            {title}
          </h2>
        )}
        <ul className="list-none space-y-8 md:space-y-4 pl-0">
          {achievements.map((achievement, index) => {
            const renderTitle = () => {
              if (!achievement.title) return null;
              
              if (achievement.url && achievement.linkText) {
                const parts = achievement.title.split(achievement.linkText);
                if (parts.length === 2) {
                  return (
                    <span className="text-base text-[#666666] font-normal leading-relaxed">
                      {parts[0]}
                      <a
                        href={achievement.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-[#666666] underline hover:no-underline"
                      >
                        {achievement.linkText}
                      </a>
                      {parts[1]}
                    </span>
                  );
                }
              }
              
              return (
                <span className="text-base text-[#666666] font-normal leading-relaxed">
                  {achievement.title}
                </span>
              );
            };

            return (
              <li key={index} className="flex items-start gap-4">
                {achievement.logo && (
                  <div className="flex-shrink-0">
                    <img
                      src={achievement.logo}
                      alt={achievement.title}
                      className="h-6 w-6 md:h-8 md:w-8 object-contain"
                    />
                  </div>
                )}
                <div className="flex-1 flex flex-col md:flex-row md:items-center md:justify-between gap-2 md:gap-0">
                  {renderTitle()}
                  {achievement.subtitle && (
                    <span className="text-sm md:text-base text-[#666666] font-normal md:text-right">
                      {achievement.subtitle}
                    </span>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default ProjectAchievements;
